import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Logo from "../images/logo1.png";
import styles from "../css/landing.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPeopleGroup,
  faBorderAll,
  faChurch,
  faListUl,
  faCoins,
  faClipboardUser,
  faListCheck,
  faUser,
  faHouse,
  faArrowRightFromBracket,
  faBars,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";

function Landing() {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const [kharisMembers, setKharisMembers] = useState([]);
  const [faithMembers, setFaithMembers] = useState([]);

  const [kharisAttendance, setKharisAttendance] = useState([]);
  const [faithAttendance, setFaithAttendance] = useState([]);

  // ================= FETCH MEMBERS =================
  useEffect(() => {
    axios
      .get("https://appserver.cemkharistemple.com/allmembers")
      .then((res) => setKharisMembers(res.data))
      .catch((err) => console.error(err));

    axios
      .get("https://appserver.cemkharistemple.com/faithallmembers")
      .then((res) => setFaithMembers(res.data))
      .catch((err) => console.error(err));
  }, []);

  // ================= FETCH ATTENDANCE =================
  useEffect(() => {
    axios
      .get("https://appserver.cemkharistemple.com/attendance")
      .then((res) => setKharisAttendance(res.data))
      .catch((err) => console.error(err));

    axios
      .get("https://appserver.cemkharistemple.com/faithattendance")
      .then((res) => setFaithAttendance(res.data))
      .catch((err) => console.error(err));
  }, []);

  // ================= COMPUTATIONS =================

  const totalMembers =
    kharisMembers.length + faithMembers.length;

  const getLatestAttendance = (data) => {
    if (!data.length) return null;

    const sorted = [...data].sort(
      (a, b) => new Date(b.service_date) - new Date(a.service_date)
    );

    return sorted[0];
  };

  const latestKharis = getLatestAttendance(kharisAttendance);
  const latestFaith = getLatestAttendance(faithAttendance);

  // GLOBAL latest (for the stats card at top)
  const globalLatestAttendance = (() => {
    const combined = [...kharisAttendance, ...faithAttendance];
    if (!combined.length) return null;

    return combined.sort(
      (a, b) => new Date(b.service_date) - new Date(a.service_date)
    )[0];
  })();

  const API_BASE_URL = useMemo(() => {
    return (
      process.env.REACT_APP_API_BASE_URL ||
      process.env.VITE_API_BASE_URL ||
      ""
    );
  }, []);

  const go = (path) => navigate(path);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  const branches = [
    {
      name: "Kharis Temple",
      route: "/kharispage",
      subtitle: "View members & reports",
      members: kharisMembers.length,
      attendance: latestKharis ? latestKharis.total_count : "—",
    },
    {
      name: "Faith Temple",
      route: "/faithpage",
      subtitle: "Attendance & finance",
      members: faithMembers.length,
      attendance: latestFaith ? latestFaith.total_count : "—",
    },
    {
      name: "Goaso Temple",
      route: "/goasopage",
      subtitle: "Departments & checks",
      members: 0,
      attendance: "—",
    },
  ];

  return (
    <div className={styles.container}>
      {/* HEADER */}
      <header className={styles.header}>
        <button
          className={styles.menuBtn}
          onClick={() => setSidebarOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <FontAwesomeIcon icon={sidebarOpen ? faXmark : faBars} />
        </button>

        <div className={styles.headerCenter}>
          <div className={styles.pageTitleWrap}>
            <h1 className={styles.pageTitle}>Dashboard</h1>
            <p className={styles.pageSubtitle}>
              Overview of branches and quick access to reports.
            </p>
          </div>
        </div>

        <div className={styles.headerRight}>
          <div className={styles.userChip} title="Admin">
            <span className={styles.userIcon}>
              <FontAwesomeIcon icon={faUser} />
            </span>
            <span className={styles.userText}>Admin</span>
          </div>

          <button
            className={styles.iconBtn}
            onClick={() => go("/landing")}
            aria-label="Home"
            title="Home"
          >
            <FontAwesomeIcon icon={faHouse} />
          </button>

          <button
            className={`${styles.iconBtn} ${styles.dangerBtn}`}
            onClick={handleLogout}
            aria-label="Logout"
            title="Logout"
          >
            <FontAwesomeIcon icon={faArrowRightFromBracket} />
          </button>
        </div>
      </header>

      {/* SIDEBAR */}
      <aside className={`${styles.sidebar} ${sidebarOpen ? styles.sidebarOpen : ""}`}>
        <div className={styles.sideTop}>
          <div className={styles.logoWrap}>
            <img src={Logo} alt="Kharis Temple" className={styles.logoImg} />
          </div>
          <div className={styles.brandText}>
            <div className={styles.brandName}>
              Kharis <span className={styles.brandAccent}>Admin</span>
            </div>
            <div className={styles.brandSmall}>Management Portal</div>
          </div>
        </div>

        <nav className={styles.nav}>
          <button className={`${styles.navItem} ${styles.navItemActive}`} onClick={() => go("/landing")}>
            <span className={styles.navIcon}>
              <FontAwesomeIcon icon={faBorderAll} />
            </span>
            <span>Dashboard</span>
          </button>

          <button className={styles.navItem} onClick={() => go("/branch-report")}>
            <span className={styles.navIcon}>
              <FontAwesomeIcon icon={faChurch} />
            </span>
            <span>Branch Report</span>
          </button>

          <button className={styles.navItem} onClick={() => go("/department-report")}>
            <span className={styles.navIcon}>
              <FontAwesomeIcon icon={faListUl} />
            </span>
            <span>Departmental Report</span>
          </button>

          <button className={styles.navItem} onClick={() => go("/finance")}>
            <span className={styles.navIcon}>
              <FontAwesomeIcon icon={faCoins} />
            </span>
            <span>Finance</span>
          </button>

          <button className={styles.navItem} onClick={() => go("/attendance")}>
            <span className={styles.navIcon}>
              <FontAwesomeIcon icon={faClipboardUser} />
            </span>
            <span>Attendance</span>
          </button>

          <button className={styles.navItem} onClick={() => go("/equipment-check")}>
            <span className={styles.navIcon}>
              <FontAwesomeIcon icon={faListCheck} />
            </span>
            <span>Equipment Check</span>
          </button>
        </nav>

        <div className={styles.sidebarFooter}>
          <div className={styles.envNote}>
            <span className={styles.envLabel}>API:</span>{" "}
            <span className={styles.envValue}>{API_BASE_URL ? "Configured" : "Not set"}</span>
          </div>
        </div>
      </aside>

      {/* MAIN */}
      <main className={styles.main}>
        {/* Stats */}
        <section className={styles.stats}>
          <div className={styles.statCard}>
            <div className={styles.statTop}>Total Branches</div>
            <div className={styles.statValue}>{branches.length}</div>
            <div className={styles.statHint}>All active locations</div>
          </div>

          <div className={styles.statCard}>
            <div className={styles.statTop}>Attendance (Latest)</div>
            <div className={styles.statValue}>
              {globalLatestAttendance
                ? globalLatestAttendance.total_count
                : "—"}
            </div>
            <div className={styles.statHint}>Latest Attendance</div>
          </div>

          <div className={styles.statCard}>
            <div className={styles.statTop}>Members</div>
            <div className={styles.statValue}>{totalMembers}</div>
            <div className={styles.statHint}>All branches combined</div>
          </div>
        </section>

        {/* Branch cards */}
        <section className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>Branches</h2>
            <p className={styles.sectionSub}>
              Open a branch to view reports and activity.
            </p>
          </div>

          <div className={styles.cards}>
            {branches.map((b) => (
              <button key={b.name} className={styles.branchCard} onClick={() => go(b.route)}>
                <div className={styles.branchCardTop}>
                  <div>
                    <h3 className={styles.branchTitle}>{b.name}</h3>
                    <p className={styles.branchSub}>{b.subtitle}</p>
                  </div>
                  <div className={styles.branchIconWrap}>
                    <FontAwesomeIcon icon={faPeopleGroup} />
                  </div>
                </div>

                <div className={styles.branchMeta}>
                  <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>Members</span>
                    <span className={styles.metaValue}>{b.members}</span>
                  </div>
                  <div className={styles.metaItem}>
                    <span className={styles.metaLabel}>Attendance</span>
                    <span className={styles.metaValue}>{b.attendance}</span>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}

export default Landing;